export const CLOVER_PAYMENT_SECTION_IDS = {
  payButton: 'pay-button'
};
